<template>
  <div class="sucesso-page" :class="{ 'com-tema': tema }">
    <template v-if="tema">
      <div class="tema-bg" :style="{ backgroundImage: `url(${tema.fundo})` }" aria-hidden="true"></div>
      <div class="tema-veil" :style="{ background: tema.veu }" aria-hidden="true"></div>
    </template>
    <div class="card sucesso-card">
      <div v-if="loading" class="state-block">
        <div class="loader" />
      </div>

      <template v-else-if="inscricao">
        <div class="icon-success">✅</div>
        <h1>Inscrição confirmada!</h1>
        <p class="msg">
          <strong>{{ inscricao.participanteNome }}</strong>, sua inscrição em
          <strong>{{ inscricao.evento.nome }}</strong> está registrada.
        </p>

        <div class="resumo">
          <div class="resumo-row">
            <span>Plano</span>
            <strong>{{ inscricao.plano.nome }}</strong>
          </div>
          <div class="resumo-row" v-if="inscricao.total > 1">
            <span>Parcelas pagas</span>
            <strong>{{ inscricao.pagas }} de {{ inscricao.total }}</strong>
          </div>
          <div class="resumo-row">
            <span>Status</span>
            <strong>{{ statusLabel }}</strong>
          </div>
        </div>

        <p v-if="inscricao.statusPagamento !== 'QUITADA'" class="parcial-help">
          As próximas parcelas vão ser cobradas automaticamente. Quando vencer,
          você receberá um lembrete e poderá pagar a parcela pelo link.
        </p>

        <router-link
          v-if="inscricao.statusPagamento === 'QUITADA' && inscricao.evento?.temCheckin"
          :to="`/inscricao/${inscricao.id}/qr`"
          class="btn-primary back"
        >
          Ver meu código de check-in
        </router-link>
        <a href="https://naelshaday.com.br" class="btn-secondary back">Voltar ao site da igreja</a>

        <ReenviarEmailLink :inscricao-id="inscricao.id" />
      </template>

      <div v-else class="state-block">
        <div class="state-icon">⚠️</div>
        <p>Inscrição não encontrada.</p>
      </div>
    </div>
  </div>
</template>

<script>
import { getSucesso } from '../../lib/inscricao'
import ReenviarEmailLink from '../../components/ui/ReenviarEmailLink.vue'
import { temaDoEvento } from '../../lib/temaDoEvento'

const STATUS_LABEL = {
  PENDENTE: 'Aguardando 1º pagamento',
  PARCIAL: 'Parcialmente pago',
  QUITADA: 'Tudo pago',
  ATRASADA: 'Parcela em atraso'
}

export default {
  name: 'SucessoPage',
  components: { ReenviarEmailLink },
  data() { return { loading: true, inscricao: null } },
  computed: {
    // Mesma razao do checkout: a confirmacao fecha o fluxo que comecou na
    // landing, e tem que parecer a mesma pagina.
    tema() {
      return temaDoEvento(this.inscricao?.evento?.slug)
    },
    statusLabel() {
      return STATUS_LABEL[this.inscricao?.statusPagamento] || this.inscricao?.statusPagamento
    }
  },
  async mounted() {
    try {
      this.inscricao = await getSucesso(this.$route.params.inscricaoId)
    } catch {}
    this.loading = false
  }
}
</script>

<style scoped>
/* Fundo do evento: a imagem vive atras do cartao, com o mesmo veu da landing.
   Sem tema, nada disso e renderizado e a tela fica exatamente como era. */
/* `absolute`, nao `fixed`: o fundo fica contido na pagina. Em `fixed` ele
   cobriria a viewport inteira, e o rodape do layout — texto cinza claro — cairia
   sobre o veu escuro e sumiria. */
.tema-bg, .tema-veil { position: absolute; inset: 0; z-index: 0; pointer-events: none; }
.tema-bg { background-position: center; background-size: cover; background-repeat: no-repeat; }
.com-tema { position: relative; }
/* O cartao sobe acima do fundo; sem isto ele ficaria coberto pelo veu. */
.com-tema > .card { position: relative; z-index: 1; }
/* Respiro no topo so quando ha tema: sem ele o cartao encosta na borda e a
   imagem so aparece embaixo — no celular o fundo quase nao se ve. Com ele a
   foto emoldura o cartao, que e o efeito da landing. */
.com-tema { padding-top: clamp(56px, 14vh, 110px); }

.sucesso-page {
  min-height: calc(100vh - 60px);
  display: flex; justify-content: center; align-items: flex-start;
  padding: var(--spacing-lg) var(--spacing-base);
}
.sucesso-card {
  width: 100%; max-width: 520px;
  padding: var(--spacing-xl);
  text-align: center;
  display: flex; flex-direction: column; align-items: center; gap: var(--spacing-md);
}
.icon-success { font-size: 64px; }
h1 { font-size: var(--text-2xl); color: var(--color-success); }
.msg { color: var(--color-text-secondary); }
.resumo {
  width: 100%;
  display: flex; flex-direction: column; gap: var(--spacing-sm);
  background: var(--color-bg-hover);
  padding: var(--spacing-base);
  border-radius: var(--radius-md);
  margin-top: var(--spacing-md);
}
.resumo-row {
  display: flex; justify-content: space-between;
  font-size: var(--text-sm);
}
.resumo-row span { color: var(--color-text-muted); }
.parcial-help {
  font-size: var(--text-sm); color: var(--color-text-muted);
  background: #f0f9ff; padding: var(--spacing-md);
  border-radius: var(--radius-md);
  margin-top: var(--spacing-md);
}
.back { margin-top: var(--spacing-lg); text-decoration: none; }
.state-block {
  display: flex; flex-direction: column; align-items: center; gap: var(--spacing-md);
  padding: var(--spacing-xl) 0;
}
.state-icon { font-size: 48px; }
.loader {
  width: 32px; height: 32px;
  border: 3px solid var(--color-bg-separator);
  border-top-color: var(--color-accent);
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}
@keyframes spin { to { transform: rotate(360deg); } }
</style>
